exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/core-js/library/modules/_object-pie.js
// module id = 148
// module chunks = 0